import React, { useEffect, useState } from "react";
import { competitionService } from "../competition/competitionService";
import UpcomingCompetetionItem from "./UpcomingCompetetionItem";
import Table from "react-bootstrap/Table";
import { showService } from '../show/showService';

const UpcomingCompetetion = () => {
  const [upcomingCompetetion, setUpcomingCompetetion] = useState([]);
  const [loading, setLoading] = useState(false);

  function getList() {
    return competitionService.indexCompetitions({
      sortOrder: "name_desc",
      searchString: "",
      pageSize: 1000,
      pageNumber: 1,
    });
  }

      function getShowsList() {
          return showService.indexShows({
              sortOrder : "name_desc", 
              searchString : "", 
              pageSize : 100, 
              pageNumber : 1
              })
      }

  async function showList() {
    try {
      setLoading(true);

      const response = await getShowsList();

      if (response.status === 200) {
        setLoading(false);

        setUpcomingCompetetion(response.data.entities);
        console.log(response.data);
      }
    } catch (error) {
      setLoading(false);

      console.error(error);
    }
  }

  useEffect(() => {
    showList();
  }, []);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  return (
    <div className="mt-5">
      <h2>Active Shows</h2>
      <div className="container mt-4">
        <Table striped hover>
          <thead>
            <tr>
              <th>Show Name</th>
              <th>Start Date</th>
                            <th>Status</th>

            </tr>
          </thead>

          <tbody>
            {upcomingCompetetion &&
              upcomingCompetetion.map((show) => (
                
                <UpcomingCompetetionItem show={show} key={show.id} />
              ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default UpcomingCompetetion;
